<template>
  <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list'>
    <template v-slot:product_name="{ record }">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
        </template>
        <template #description>
          <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
        </template>
      </a-card-meta>
    </template>
    <template v-slot:real_num="{ record }">{{record.hasOwnProperty('out_warehousing_real_num')?record.out_warehousing_real_num:record.refund_warehousing_num ||record.transfer_warehousing_real_num 
      }}</template>
  </a-table>
</template>
<script>
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import store from "@/store";
  export default {
    components: {},
    props: {
      listdata: Array
    },
    setup(props) {
      const state = reactive({
        info: store.state.user.info,
        list: [],
        columns: [
          {

            title: "批次名称",
            dataIndex: "product_batch_name",
            key: "product_batch_name",
            customRender: ({ record }) => {
              return record.product_batch_name == '0' || !record.product_batch_name ?  '-' : record.product_batch_name
            }
          },
          {
            title: "商品编码",
            dataIndex: "product_sn",
            key: "product_sn"
          },
          {
            title: "商品信息",
            dataIndex: "product_name",
            key: "product_name",
            slots: { customRender: "product_name" },
          },
          {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender: ({ record }) => {
              return record.product_sku_name ? record.product_sku_name : '单规格'
            }
          },
          {
            title: "订单数量",
            dataIndex: "out_warehousing_num",
            key: "out_warehousing_num",
            customRender: ({ record }) => {
              return record.out_warehousing_num ? record.out_warehousing_num : record.transfer_warehousing_num? record.transfer_warehousing_num :"-"
            }
          },
          {
            title: "实发数量",
            dataIndex: "real_num",
            key: "real_num",
            slots: { customRender: "real_num" },
          }
        ]
      });
      onMounted(() => {
        state.list = props.listdata
      });
      return {
        ...toRefs(state),
      };
    },
  };
</script>